// src/components/ResetPassword.jsx
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../services/api';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      setLoading(true);
      const res = await forgotPassword(email);
      setMessage(res.message || 'Password reset link sent to your email');
    } catch (err) {
      setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xxl-4 col-xl-5 col-md-6 d-md-block d-none ps-0">
          <div className="login-image">
            <div className="login-logo">
              <h4 className="text-white">Logo</h4>
            </div>
            <div className="login-content">
              <h3 className="text-white head-xs font-600">“Sending money worldwide is now instant, secure, and effortless.”</h3>
              <p className="text-white text-sm font-400 pt-2">Send, receive, and relax — your money’s already there.</p>
            </div>
          </div>
        </div>
        <div className="col-xxl-8 col-xl-7 col-md-6">
          <div className="row vh-100 align-items-center justify-content-center">
            <div className="col-xxl-6 col-xl-10">
              <div className="p-4">
                <div className="text-center pb-4">
                  <h3 className="theme-text-black head-sm font-600 pb-2">Forgot Your Password?</h3>
                  <p className="theme-text-color text-sm font-500 pb-2">Securely reset your password and regain access to your account.</p>
                </div>
                <div className="">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <button className="theme-btn justify-content-center w-100" disabled={loading}>
                      {loading ? 'Sending...' : 'Send Forgot Link'}
                    </button>

                    {error && <p className="text-danger mt-2">{error}</p>}
                    {message && <p className="text-success mt-2">{message}</p>}

                  </form>
                </div>
                <div className="login-divider">
                  <p>Or</p>
                </div>
                <div className="text-center">
                  <small className="text-muted">
                    Want to go back?{' '}
                    <Link to="/login" className="text-primary fw-semibold">
                      Login
                    </Link>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
